import React, { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL  from "../../BaseUrl.jsx";
import "../../styles/owner/Statistics.css"; // Import the CSS file for styling

export default function Statistics(){
  const [data, setData] = useState({
        students: 0,
        registeredStudents: 0,
        teachers: 0,
        lessons: 0,
        boughtLessons: 0,
        courses: 0,
        exams: 0,
    });
    useEffect(()=>{
      axios.get(`${BASE_URL}/owner/statistics`, { withCredentials: true })
        .then((response) => {
          console.log(response.data);
          setData(response.data);
        })
        .catch((error) => {
          console.error("Failed to fetch statistics:", error);
        });
    }, []);
    const handleBack = () => {
        window.history.back();
    };

    return (
        <div className="students-page" dir="rtl">

            {/* Back Button */}
            <button
                className="students-back-button"
                onClick={handleBack}
            >
                ← العودة
            </button>

            {/* Header */}

            {/* Statistics */}
            <div className="students-statistics">
                <div className="student-stat-card">
                    <h2>الطلاب</h2>
                    <p>{data.students}</p>
                </div>

                <div className="student-stat-card">
                    <h2>الطلاب المسجلين</h2>
                    <p>{data.registeredStudents}</p>
                </div>

                <div className="student-stat-card">
                    <h2>المدرسين</h2>
                    <p>{data.teachers}</p>
                </div>

                <div className="student-stat-card">
                    <h2>الدروس</h2>
                    <p>{data.lessons}</p>
                </div>

                <div className="student-stat-card">
                    <h2>الدروس المشتراة</h2>
                    <p>{data.boughtLessons}</p>
                </div>

                
                <div className="student-stat-card">
                    <h2>المواد</h2>
                    <p>{data.courses}</p>
                </div>

                <div className="student-stat-card">
                    <h2>الامتحانات</h2>
                    <p>{data.exams}</p>
                </div>

            </div>

        </div>
    );


}

    


    